// import React from "react";
// import {
//   Container,
//   Typography,
//   Box,
//   useTheme,
//   alpha,
//   Chip
// } from "@mui/material";

// const Support = () => {
//   const theme = useTheme();

//   return (
//     <Container maxWidth="lg" sx={{ py: 8 }}>
//       <Box sx={{ textAlign: "center", mb: 6 }}>
//         <Chip 
//           label="Page Category" 
//           sx={{ 
//             mb: 3,
//             background: alpha(theme.palette.primary.main, 0.1),
//             color: theme.palette.primary.dark,
//             fontWeight: 600,
//             fontSize: "0.85rem"
//           }}
//         />
//         <Typography
//           variant="h2"
//           sx={{
//             fontWeight: 700,
//             color: theme.palette.text.primary,
//             mb: 3,
//             fontSize: { xs: "2.5rem", md: "3rem" }
//           }}
//         >
//           Page Title
//         </Typography>
//         <Typography
//           variant="h6"
//           sx={{
//             color: theme.palette.text.secondary,
//             maxWidth: "800px",
//             mx: "auto",
//             lineHeight: 1.6,
//             fontSize: "1.1rem"
//           }}
//         >
//           Page content goes here. This is a placeholder that you can replace with 
//           actual content specific to this page.
//         </Typography>
//       </Box>

//       {/* Add more sections as needed */}
//     </Container>
//   );
// };

// export default Support;



import React, { useState } from "react";
import {
  Typography,
  Box,
  useTheme,
  alpha,
  Grid,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  Button,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Paper,
  Avatar,
  IconButton,
  Divider,
  Alert,
  Snackbar,
  Tabs,
  Tab,
  Fade,
} from "@mui/material";
import { Link } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import EmailIcon from "@mui/icons-material/Email";
import ChatIcon from "@mui/icons-material/Chat";
import PhoneIcon from "@mui/icons-material/Phone";
import HelpCenterIcon from "@mui/icons-material/HelpCenter";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import StarIcon from "@mui/icons-material/Star";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import SupportLayout from "../Support/SupportLayout";

const CleanerFAQItem = ({ question, answer, icon, category, isExpanded = false }) => {
  const theme = useTheme();
  const [expanded, setExpanded] = useState(isExpanded);
  const [feedback, setFeedback] = useState(null);
  const [copySuccess, setCopySuccess] = useState(false);

  const handleCopyLink = () => {
    const url = `${window.location.origin}/cleaner-support?search=${encodeURIComponent(question)}`;
    navigator.clipboard.writeText(url);
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 2000);
  };

  const getCategoryColor = (cat) => {
    switch(cat) {
      case "earnings": return "#10b981";
      case "scheduling": return "#3b82f6";
      case "reviews": return "#f59e0b";
      case "issues": return "#ef4444";
      default: return theme.palette.primary.main;
    }
  };

  return (
    <Paper
      elevation={0}
      sx={{
        mb: 2,
        borderRadius: 2,
        border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
        transition: "all 0.2s",
        "&:hover": {
          borderColor: alpha(theme.palette.primary.main, 0.3),
          boxShadow: theme.shadows[2],
        },
      }}
    >
      <Accordion
        expanded={expanded}
        onChange={() => setExpanded(!expanded)}
        sx={{
          boxShadow: "none",
          "&:before": { display: "none" },
          "&.Mui-expanded": { margin: 0 },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{
            p: 2,
            "& .MuiAccordionSummary-content": {
              alignItems: "center",
            },
          }}
        >
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: 2,
              background: alpha(getCategoryColor(category), 0.1),
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mr: 2,
              color: getCategoryColor(category),
            }}
          >
            {icon}
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              {question}
            </Typography>
            <Chip
              label={category}
              size="small"
              sx={{
                mt: 0.5,
                height: 20,
                fontSize: "0.7rem",
                background: alpha(getCategoryColor(category), 0.1),
                color: getCategoryColor(category),
              }}
            />
          </Box>
        </AccordionSummary>

        <AccordionDetails sx={{ pt: 0 }}>
          <Divider sx={{ mb: 2 }} />
          <Typography variant="body1" sx={{ color: "text.secondary", mb: 2, lineHeight: 1.6 }}>
            {answer}
          </Typography>

          {/* Helpful buttons */}
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mt: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Typography variant="caption" color="text.secondary">
                Was this helpful?
              </Typography>
              <IconButton
                size="small"
                onClick={() => setFeedback("yes")}
                sx={{ color: feedback === "yes" ? theme.palette.success.main : "inherit" }}
              >
                <ThumbUpIcon fontSize="small" />
              </IconButton>
              <IconButton
                size="small"
                onClick={() => setFeedback("no")}
                sx={{ color: feedback === "no" ? theme.palette.error.main : "inherit" }}
              >
                <ThumbDownIcon fontSize="small" />
              </IconButton>
            </Box>
            <IconButton size="small" onClick={handleCopyLink}>
              <ContentCopyIcon fontSize="small" />
            </IconButton>
          </Box>

          <Snackbar
            open={copySuccess}
            autoHideDuration={2000}
            message="Link copied to clipboard!"
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          />
        </AccordionDetails>
      </Accordion>
    </Paper>
  );
};

const CleanerSupport = () => {
  const theme = useTheme();
  const [searchQuery, setSearchQuery] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const faqsData = {
    earnings: [
      {
        id: "earn1",
        question: "How do I get paid for completed cleanings?",
        answer: "Payments are automatically processed every Monday for all completed cleanings from the previous week (Monday to Sunday). Funds are deposited directly to your linked bank account or Stripe account within 2-3 business days. You can track your earnings in real-time through the Earnings Dashboard.",
        category: "earnings",
        icon: <AccountBalanceWalletIcon />,
      },
      {
        id: "earn2",
        question: "What is the commission rate for cleaners?",
        answer: "Cleaners keep 80% of each booking value. The 20% platform fee covers insurance, payment processing, customer support, and marketing. Top-rated cleaners with 100+ completed jobs qualify for a reduced 15% commission rate.",
        category: "earnings",
        icon: <AccountBalanceWalletIcon />,
      },
      {
        id: "earn3",
        question: "When can I withdraw my earnings?",
        answer: "Earnings are automatically paid out weekly. You can also request instant payout for a small fee of 1.5% through the Earnings section. Minimum withdrawal amount is $50 for standard payout and $20 for instant payout.",
        category: "earnings",
        icon: <AccountBalanceWalletIcon />,
      },
    ],
    scheduling: [
      {
        id: "sched1",
        question: "How do I accept or decline cleaning requests?",
        answer: "When you receive a cleaning request notification, open the app and review the details (location, time, scope of work). Tap 'Accept' to confirm or 'Decline' if unavailable. You have 2 hours to respond before the offer expires.",
        category: "scheduling",
        icon: <CalendarTodayIcon />,
      },
      {
        id: "sched2",
        question: "Can I set my availability preferences?",
        answer: "Yes! Go to Profile → Availability Settings. You can set your working hours, days off, preferred service radius, and the maximum distance you're willing to travel. This helps match you with suitable jobs automatically.",
        category: "scheduling",
        icon: <CalendarTodayIcon />,
      },
      {
        id: "sched3",
        question: "What happens if I need to cancel a confirmed booking?",
        answer: "You can cancel up to 24 hours before the scheduled time without penalty. Cancellations within 24 hours may affect your completion rate and could result in temporary account restrictions. Use the 'Request Cancellation' feature with a valid reason.",
        category: "scheduling",
        icon: <CalendarTodayIcon />,
      },
    ],
    reviews: [
      {
        id: "rev1",
        question: "How are cleaner ratings calculated?",
        answer: "Your overall rating is an average of all customer reviews across five categories: punctuality, quality of work, professionalism, communication, and value. Ratings are updated in real-time as new reviews come in.",
        category: "reviews",
        icon: <StarIcon />,
      },
      {
        id: "rev2",
        question: "Can I respond to customer reviews?",
        answer: "Absolutely! You can respond to any review within 14 days. Go to Job History → Select the job → 'Respond to Review'. Professional responses to both positive and negative feedback are encouraged and show your commitment to quality.",
        category: "reviews",
        icon: <StarIcon />,
      },
      {
        id: "rev3",
        question: "How can I improve my rating?",
        answer: "Focus on communication, arrive on time, complete the full checklist, and follow special instructions. Top-rated cleaners also bring their own high-quality supplies and go above and beyond by offering small extras like organizing or taking out trash.",
        category: "reviews",
        icon: <StarIcon />,
      },
    ],
    issues: [
      {
        id: "issue1",
        question: "What should I do if a customer isn't satisfied?",
        answer: "Listen to their concerns professionally. If possible, offer to re-clean the specific areas. Report the issue through the app within 24 hours with photos. Our support team will mediate and ensure fair resolution.",
        category: "issues",
        icon: <ReportProblemIcon />,
      },
      {
        id: "issue2",
        question: "What if I encounter an unsafe situation?",
        answer: "Your safety is our priority. If you feel unsafe, leave immediately and report through the Emergency button in the app. Our 24/7 safety team will assist you and investigate the situation. You won't be penalized for leaving unsafe environments.",
        category: "issues",
        icon: <ReportProblemIcon />,
      },
      {
        id: "issue3",
        question: "How do I report a customer issue?",
        answer: "Go to Job Details → 'Report Issue'. Provide detailed information and upload photos/videos (max 10 files). Our team will investigate within 24 hours. For urgent issues, call our support hotline immediately.",
        category: "issues",
        icon: <ReportProblemIcon />,
      },
    ],
  };

  const allFAQs = [
    ...faqsData.earnings.map(f => ({ ...f })),
    ...faqsData.scheduling.map(f => ({ ...f })),
    ...faqsData.reviews.map(f => ({ ...f })),
    ...faqsData.issues.map(f => ({ ...f })),
  ];

  const filteredFAQs = searchQuery
    ? allFAQs.filter(faq =>
        faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
        faq.answer.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : [];

  const contactMethods = [
    {
      id: 1,
      title: "Email Support",
      subtitle: "cleaners@freshsweeper.com",
      icon: <EmailIcon />,
      color: theme.palette.primary.main,
      action: () => window.location.href = "mailto:cleaners@freshsweeper.com",
    },
    {
      id: 2,
      title: "Live Chat",
      subtitle: "Available 24/7",
      icon: <ChatIcon />,
      color: "#10b981",
      action: () => window.open("/live-chat", "_blank"),
    },
    {
      id: 3,
      title: "Phone Support",
      subtitle: "1-800-CLEANER",
      icon: <PhoneIcon />,
      color: "#f59e0b",
      action: () => window.location.href = "tel:+18001234567",
    },
    {
      id: 4,
      title: "Help Center",
      subtitle: "Video tutorials & guides",
      icon: <HelpCenterIcon />,
      color: "#8b5cf6",
      action: () => window.location.href = "/help",
    },
  ];

  const stats = [
    { value: "24/7", label: "Support Available" },
    { value: "< 2hr", label: "Avg Response Time" },
    { value: "98%", label: "Satisfaction Rate" },
    { value: "50k+", label: "Jobs Completed" },
  ];

  const quickTips = [
    "Always confirm bookings within 2 hours",
    "Take before/after photos for every job",
    "Communicate arrival time via chat",
    "Review special instructions before arrival",
    "Rate customers after each job",
    "Update availability weekly",
  ];

  const handleContactClick = (method) => {
    setSnackbarMessage(`Opening ${method.title}...`);
    setSnackbarOpen(true);
    setTimeout(() => method.action(), 500);
  };

  return (
    <SupportLayout
      title="Cleaner Support Center"
      category="Cleaner Help"
      subtitle="Everything you need to succeed as a FreshSweeper cleaner"
      breadcrumbs={[
        { label: "Cleaner Home", link: "/cleaner" },
        { label: "Support" },
      ]}
      stats={stats}
    >
      {/* Search Bar */}
      <Paper
        elevation={0}
        sx={{
          p: 1,
          mb: 4,
          borderRadius: 3,
          border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
        }}
      >
        <TextField
          fullWidth
          placeholder="Search for answers..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          variant="standard"
          InputProps={{
            disableUnderline: true,
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: theme.palette.text.secondary, ml: 1 }} />
              </InputAdornment>
            ),
            endAdornment: searchQuery && (
              <InputAdornment position="end">
                <Button onClick={() => setSearchQuery("")} size="small">
                  Clear
                </Button>
              </InputAdornment>
            ),
            sx: { py: 1.5, px: 1 },
          }}
        />
      </Paper>

      {/* Quick Tips Banner */}
      <Alert
        severity="info"
        icon={<CheckCircleIcon />}
        sx={{ mb: 4, borderRadius: 2 }}
      >
        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
          💡 Quick Tips for Success
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
          {quickTips.map((tip, idx) => (
            <Chip key={idx} label={tip} size="small" variant="outlined" />
          ))}
        </Box>
      </Alert>

      {/* Contact Methods */}
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
        Quick Contact
      </Typography>
      <Grid container spacing={2} sx={{ mb: 5 }}>
        {contactMethods.map((method) => (
          <Grid item xs={6} sm={3} key={method.id}>
            <Card
              sx={{
                textAlign: "center",
                cursor: "pointer",
                transition: "transform 0.2s",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: theme.shadows[4],
                },
              }}
              onClick={() => handleContactClick(method)}
            >
              <CardContent>
                <Avatar
                  sx={{
                    width: 56,
                    height: 56,
                    mx: "auto",
                    mb: 1,
                    bgcolor: alpha(method.color, 0.1),
                    color: method.color,
                  }}
                >
                  {method.icon}
                </Avatar>
                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                  {method.title}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {method.subtitle}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Search Results or FAQ Categories */}
      {searchQuery ? (
        <Box>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
            Search Results ({filteredFAQs.length})
          </Typography>
          {filteredFAQs.length > 0 ? (
            filteredFAQs.map((faq, idx) => (
              <CleanerFAQItem
                key={idx}
                question={faq.question}
                answer={faq.answer}
                icon={faq.icon}
                category={faq.category}
                isExpanded={true}
              />
            ))
          ) : (
            <Paper sx={{ p: 4, textAlign: "center", borderRadius: 3 }}>
              <SearchIcon sx={{ fontSize: 64, color: "text.disabled", mb: 2 }} />
              <Typography variant="h6">No results found</Typography>
              <Typography variant="body2" color="text.secondary">
                Try different keywords or browse the categories below
              </Typography>
            </Paper>
          )}
        </Box>
      ) : (
        <>
          {/* FAQ Categories with Tabs */}
          <Tabs
            value={activeTab}
            onChange={(e, val) => setActiveTab(val)}
            sx={{ mb: 3, borderBottom: 1, borderColor: "divider" }}
            variant="fullWidth"
          >
            <Tab label="💰 Earnings" />
            <Tab label="📅 Scheduling" />
            <Tab label="⭐ Reviews" />
            <Tab label="⚠️ Issues" />
          </Tabs>

          <Fade in={activeTab === 0}>
            <Box sx={{ display: activeTab === 0 ? "block" : "none" }}>
              <Typography variant="h5" sx={{ mb: 3, fontWeight: 700 }}>
                Earnings & Payments
              </Typography>
              {faqsData.earnings.map((faq, idx) => (
                <CleanerFAQItem
                  key={idx}
                  question={faq.question}
                  answer={faq.answer}
                  icon={faq.icon}
                  category={faq.category}
                />
              ))}
            </Box>
          </Fade>

          <Fade in={activeTab === 1}>
            <Box sx={{ display: activeTab === 1 ? "block" : "none" }}>
              <Typography variant="h5" sx={{ mb: 3, fontWeight: 700 }}>
                Scheduling & Bookings
              </Typography>
              {faqsData.scheduling.map((faq, idx) => (
                <CleanerFAQItem
                  key={idx}
                  question={faq.question}
                  answer={faq.answer}
                  icon={faq.icon}
                  category={faq.category}
                />
              ))}
            </Box>
          </Fade>

          <Fade in={activeTab === 2}>
            <Box sx={{ display: activeTab === 2 ? "block" : "none" }}>
              <Typography variant="h5" sx={{ mb: 3, fontWeight: 700 }}>
                Reviews & Ratings
              </Typography>
              {faqsData.reviews.map((faq, idx) => (
                <CleanerFAQItem
                  key={idx}
                  question={faq.question}
                  answer={faq.answer}
                  icon={faq.icon}
                  category={faq.category}
                />
              ))}
            </Box>
          </Fade>

          <Fade in={activeTab === 3}>
            <Box sx={{ display: activeTab === 3 ? "block" : "none" }}>
              <Typography variant="h5" sx={{ mb: 3, fontWeight: 700 }}>
                Issues & Emergencies
              </Typography>
              {faqsData.issues.map((faq, idx) => (
                <CleanerFAQItem
                  key={idx}
                  question={faq.question}
                  answer={faq.answer}
                  icon={faq.icon}
                  category={faq.category}
                />
              ))}
            </Box>
          </Fade>
        </>
      )}

      {/* Still Need Help Banner */}
      <Paper
        sx={{
          mt: 5,
          p: 4,
          borderRadius: 3,
          textAlign: "center",
          background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, ${alpha(theme.palette.primary.light, 0.02)} 100%)`,
        }}
      >
        <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
          Still have questions?
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Our dedicated cleaner support team is available 24/7
        </Typography>
        <Button
          variant="contained"
          size="large"
          component={Link}
          to="/contact"
          sx={{ borderRadius: 2 }}
        >
          Contact Cleaner Support
        </Button>
      </Paper>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
    </SupportLayout>
  );
};

export default CleanerSupport;